import { EnvironmentProviders, makeEnvironmentProviders } from '@angular/core';

import { HTTP_ERROR_CLAIM_HANDLER } from '@mp/shared/data-access';

import { MaintenanceLockClaimHandler, MaintenanceSettingsService, MaintenanceStateService } from '../services';
import { MaintenanceSettingsFacade } from '../store';

/**
 * Registers the data access of the maintenance mode.
 * @returns The environment providers of the maintenance data access.
 */
export function provideMaintenanceDataAccess(): EnvironmentProviders {
  return makeEnvironmentProviders([
    MaintenanceStateService,
    MaintenanceSettingsService,
    MaintenanceSettingsFacade,
    // Die markierten 503er der Sperre gehören dieser Bibliothek, nicht der globalen Fehlerbehandlung.
    { provide: HTTP_ERROR_CLAIM_HANDLER, useExisting: MaintenanceLockClaimHandler, multi: true },
  ]);
}
